// src/modules/app-views/products/pages/Init/components/tableColumns/unitColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function unitColumn(buildColumnProps, options = {}) {
  const {
    key = 'unit',
    title = 'unit',
    dataIndex = 'unit',
    width = 80,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const unit = r?.unit;
      if (!unit) return '—';
      // Handle hydrated object format: { uid, name, description }
      if (typeof unit === 'object' && unit !== null) {
        return unit.name || '—';
      }
      return unit;
    },
  };
}

export default unitColumn;
